import React from "react";
import QuoteRequests from "./QuoteRequests";
import { useSearchParams } from "react-router-dom";

const QuoteRequestsPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  let search = searchParams.get("search");
  let status = searchParams.get("status");

  return <QuoteRequests search={search} status={status ?? "DRAFT_AND_SENT"} />;
};

export default QuoteRequestsPage;
